/**
 * @author yan st
 * @date 2023-11-13 09:59
 * @Description:
 */

export const homeRouter = [
  {
    path: '',
    redirect: 'index'
  },
  {
    path: 'index',
    meta: {
      title: '合同准合同纠纷',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/index'),
  },
  {
    path: 'indexa',
    meta: {
      title: '劳动争议人事争议',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/indexa'),
  },
  {
    path: 'indexb',
    meta: {
      title: '知识产权与竞争纠纷',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/indexb'),
  },
  {
    path: 'indexDetail',
    meta: {
      title: '详情',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/indexDetail'),
  },
  {
    path: 'indexTest',
    meta: {
      title: '测试',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/page/indexTest'),
  },
]

export default homeRouter
